module.exports = __webpack_public_path__ + "img/mothejwa-profile-min.015ec814.jpg";